const playTabConfig = {
  modules: [
    {
      name: 'pokerish',
      enabled: false,
    },
    {
      name: 'firstGame',
      enabled: true,
    },
    {
      name: 'advisorPromo',
      enabled: true,
    },
    {
      name: 'practiceGame',
      enabled: true,
    },
    {
      name: 'joinGame',
      enabled: true,
    },
    {
      name: 'createGame',
      enabled: true,
    },
    {
      name: 'createTournament',
      enabled: true,
    },
    {
      name: 'lounges',
      enabled: true,
    },
    {
      name: 'badges',
      enabled: true,
    },
    {
      name: 'yourGames',
      enabled: true,
    },
    {
      name: 'communityGames',
      enabled: true,
    },
    {
      name: 'handRankings',
      enabled: false,
    }
  ],
  variation: 'default'
}

export default playTabConfig
